import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { NgProgress } from 'ngx-progressbar';
import { PadraoService } from "../service/padrao.service";
import { Locale } from "../util/locale.ptbr";
import { Helpers } from '../util/helpers';
import { SelectItem } from 'primeng/components/common/selectitem';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs';
import * as FileSaver from 'file-saver';
import { ObservableUtil, ObservableBlockPanel, ObservableLotacao, bObservableUsuario, ObservableBlockPanelDoc } from '../util/observable-util';
import { EpcImplementation, RegistroImplementation } from '../base/use-system/implementation-system/index';
import { CriarSistema } from './use-system/interface-system/system-interface';
import { AppTopBar } from '../app.topbar.component';
import { Location } from '@angular/common';
import { EventEmitterService } from 'app/util/emitter-service/emitter-service';
import { EVENT_MSGS_UPDATE } from 'app/util/emitter-service/nome-evento';

@Component({ template: '' })
export class BaseComponent implements OnInit  {
    controllerName: string = '';
    contentCheck: number = 0;
    today = Date.now();
    yearRange = new Date();
    dataRange;
    lastYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    msgs: Message[] = [];
    perfilLotado: any;
    @Input() isValid: boolean = false;
    @Output() isValidChange = new EventEmitter<boolean>();
    @Output() validateFormChange = new EventEmitter<any>();
    @Input() validateForm: any = false;

    constructor(public formBuilder: FormBuilder,
        public ngProgress: NgProgress,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public service: PadraoService,
        public confirmacao: ConfirmationService,
        public locale: Locale,
        public help: Helpers,
        public observableUtilPanel: ObservableBlockPanel,
        public observableUtilPanelDoc: ObservableBlockPanelDoc,
        public observableUtilLotacao: ObservableLotacao,
        public bObservale: bObservableUsuario,
        public location: Location
    ) { }
    /**
     * Instancia do sistema a ser usado para validar as enums e realizar a funções especificas para a datatable de cada sistema
     */
    sistema = CriarSistema(RegistroImplementation, this.router, this.activatedRoute, this.service, this.confirmacao, this.msgs, this.bObservale);

    init(optional1?: any, optional2?: any) { };
    afterInit(optional1?: any, optional2?: any) { };
    afterLoad(optional1?: any, optional2?: any) { };

    ngOnInit() {
        this.init();
        this.afterInit();
        this.afterLoad();
    }

    getItemBy(arr: any, filter: any) {
        if (arr == null)
            return "";
        let ret = arr.find(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] != filter[fkey])
                    select = false;
            });
            return select;
        });
        return ret ? ret : "";
    }

    listItemBy(arr: any, filter: any) {
        if (arr == null)
            return [];
        let ret = arr.filter(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] != filter[fkey])
                    select = false;
            });
            return select;
        });
        return ret ? ret : [];
    }

    showMsg(severity: string, summary: string, detail: string) {
        this.msgs = [];
        this.msgs.push({ severity: severity, summary: summary, detail: detail });
        EventEmitterService.get(EVENT_MSGS_UPDATE).emit(this.msgs);
    }

    touchAll(formGroup: FormGroup | FormArray, func = 'markAsDirty', opts = { onlySelf: false }): void {
        Object.keys(formGroup.controls).map((key, index) => {
            let obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray)
                this.touchAll(obj, func, opts);
            else
                obj[func](opts);
        });
    }

    setValidators(formGroup: FormGroup | FormArray, validator: any): void {
        Object.keys(formGroup.controls).map((key, index) => {
            let obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray)
                this.setValidators(obj, validator);
            else
                obj.setValidators(validator);
        });
    }

    verifyControlsEmpty(formGroup: FormGroup | FormArray, controlNameExcept?: string): boolean {
        let count: number = 0;
        Object.keys(formGroup.controls).map((key, index) => {
            const obj = formGroup.controls[key];
            if ((obj.value === undefined || obj.value === null || obj.value === '') && controlNameExcept !== key) {
                count++;
            }
        });
        if (count > 0) return false;
        else return true;
    }

    validateListExists(list: any, obj: any) {
        if (this.getItemBy(list, obj) != "") {
            this.showMsg('warn', 'Mensagem de Aviso', `Já existe um registro na lista com esses dados.`)
            return true;
        } else {
            return false;
        }
    }

    addToList(list: any, listEmit: EventEmitter<any>, form: FormGroup, event: any, validationObj: any = null, customData: any = null) {
        if (validationObj != null && this.validateListExists(list, validationObj)) return;

        if (form.valid) {
            list.push(Object.assign({}, form.value, customData));
            list = [...list];
            listEmit.emit(list);

            form.reset();
            this.touchAll(form, 'markAsPristine');
        } else {
            this.touchAll(form);
        }
    }

    removeFromList(list: any[], listEmit: EventEmitter<any>, index: number, message: string, minLength: number = 0) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Deseja mesmo remover esse item da lista ${message}?`,
            accept: () => {
                list.splice(index, 1);
                list = [...list];
                listEmit.emit(list)
                this.isValidChange.emit(this.isValid = false);
                if (list.length < minLength)
                    this.showMsg('warn', 'Mensagem de Alerta', `É necessaria a inclusão de ao menos ${minLength} ${message}`);

            }
        });
    }

    loadEnumAsList(enumeration: any): any {
        let half = typeof enumeration == "object" ? (Object.keys(enumeration).length * 0.5) : enumeration.length;
        return Object.keys(Object.assign({}, enumeration)).filter((key, i) => (i < half)).map((key, i, obj) => obj[key] = { value: key, label: obj[key] });
    }

    loadListAsEnum(lista: SelectItem[], enumeration: any) {
        for (let i = 1; i <= Object.keys(enumeration).length / 2; i++) {
            lista.push({ value: i, label: enumeration[i] });
        }
    }


    getControlName(c: AbstractControl): string | null {
        const formGroup = c.parent.controls;
        return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
    }

    limpaCaracterEspecial(campo: string): string {
        if (campo != null)
            return campo.replace(/[^0-9A-Za-z]/g, '');
        else return '';
    }

    FormatCodigoCFC(campo: string): string {
        if (campo != null)
            return campo.replace(/[^0-9A-Za-z\-]/g, '');
        else return '';
    }

    public readFile(fileToRead: File): Observable<MSBaseReader> {
        const base64Observable = new ReplaySubject<MSBaseReader>(1);

        const fileReader = new FileReader();
        fileReader.onload = event => {
            base64Observable.next(fileReader.result);
        };
        fileReader.readAsDataURL(fileToRead);

        return base64Observable;
    }

    b64toFile(b64Data, filename, contentType) {
        var sliceSize = 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var file = new File(byteArrays, filename, { type: contentType });
        return file;
    }

    downloadFile(id: number, fileName: string, key: string, classtype: string) {
        this.service.ObterAnexo(`arquivo`, id, key, classtype).subscribe(
            data => {
                FileSaver.saveAs(this.b64toFile(data, null, "application/octet-stream"), fileName);
                this.showMsg('success', 'Mensagem de Sucesso', `O arquivo '${fileName}' foi baixado automaticamente, verifique na pasta de downloads.`);
            }
            , err => this.showMsg('danger', 'Mensagem de Erro', `Houve um erro ao baixar o arquivo. ${err}`)
        );
    }

    onSelectFileUploadList(event, uploadedFiles: any[], uploadedFilesChange: EventEmitter<any[]>, customData: any = null) {
        for (const file of event.files) {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            if (file.size < 10000000) {
                this.readFile(file).subscribe(f => {
                    uploadedFiles.push(Object.assign({
                        nome_upload: f, nome_arquivo: file.name,
                        tamanho: file.size, extensao: null, id: 0
                    }, customData)
                    );
                    uploadedFiles = [...uploadedFiles];
                    uploadedFilesChange.emit(uploadedFiles);
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                });
            }
        }
    }

    emitValidation(list: any) {
        if (list.length > 0) {
            this.isValid = true;
        } else {
            this.isValid = false;
        }
        this.isValidChange.emit(this.isValid);
    }

    exportarExcel(rota: string, filtro: any, nomeAquivo: string, msgSucesso?: string, msgErro?: string) {
        msgSucesso = !msgSucesso.length ? 'O arquivo foi exportado com sucesso.' : msgSucesso;
        msgErro = !msgErro.length ? 'Houve um erro ao imprimir o arquivo' : msgSucesso;
        this.service.ObterExcel(rota, filtro).subscribe(
            x => {
              FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), nomeAquivo);
              this.showMsg('success', 'Mensagem de Sucesso', `${msgSucesso}`);
              this.observableUtilPanelDoc.setBlockedPanel(false);
            },
            err => {
              this.showMsg('danger', 'Mensagem de Erro', `${msgErro} - ${err}`);
              this.observableUtilPanelDoc.setBlockedPanel(false);
            }
          );
    }

    exportarPdf(rota: string, filtro: any, nomeAquivo: string, msgSucesso?: string, msgErro?: string) {
        msgSucesso = !msgSucesso.length ? 'O arquivo foi impresso com sucesso.' : msgSucesso;
        msgErro = !msgErro.length ? 'Houve um erro ao imprimir o arquivo' : msgSucesso;
        this.service.ObterPdf(rota, filtro).subscribe(
            x => {
              FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), nomeAquivo);
              this.showMsg('success', 'Mensagem de Sucesso', `${msgSucesso}`);
              this.observableUtilPanelDoc.setBlockedPanel(false);
            },
            err => {
              this.showMsg('danger', 'Mensagem de Erro', `${msgErro} - ${err}`);
              this.observableUtilPanelDoc.setBlockedPanel(false);
            }
          );
    }

    voltar() {
        this.location.back()
    }
}


// WEBPACK FOOTER //
// ./src/app/base/base.component.ts